import { HTTP } from "@/helpers/http-common"

const url = "/api/base"

const list = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/list`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const listDetalle = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/listDetalle`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const listExclusiones = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/listExclusiones`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const disable = (data) => new Promise((resolve, reject) => {
  const { clave } = data;
  HTTP.delete(url, { params: { clave } }).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error.response);
  });
});

const email = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/email`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

export default {
  list
  , listDetalle
  , listExclusiones
  , disable
  , email
}


// WEBPACK FOOTER //
// ./src/services/bases/base/index.js